
import { ReactNode } from "react";
import { Theme } from "@mui/material/styles";

import Box from "../Box";
import Typography from "../Typography";


interface IProps {
    children: ReactNode;
    noPad?: boolean;
    bgcolor?: string;
    noBorder?: boolean;
    borderColor?: string;
    width?: string | number;
    align?: "left" | "right" | "center";
}

const DataTableBodyCell = ({ width, noBorder, noPad, align, bgcolor, borderColor, children }: IProps): JSX.Element => {
    return (
        <Box
            component="td"
            textAlign={align}
            py={1.5}
            px={noPad ? 1 : 3}
            sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }: Theme) => ({
                fontSize: size.sm,
                borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${borderColor || light.main}`,
                bgcolor: bgcolor,
            })}
        >
            <Box
                color="text"
                width={width}
                display="inline-block"
                sx={{
                    verticalAlign: "middle",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    width: width,
                }}
            >
                <Typography variant="caption" fontWeight="medium" color="text">
                    {children}
                </Typography>
            </Box>
        </Box >
    );
}

DataTableBodyCell.defaultProps = {
    noPad: false,
    noBorder: false,
    align: "left",
};

export default DataTableBodyCell;
